import Dict from '@/utils/dict-utils'

// 服务费收取单位
export const chargeUnitTypeDict = new Dict({
  WINNER: { label: '中标单位', value: 0 },
  BIDDER: { label: '招标单位', value: 1 }
})

// 金额填写方式
export const amountFillTypeDict = new Dict({
  DIFFERENCE: { label: '每单位不同', value: 1 },
  SAME: { label: '固定金额', value: 0 }
})

// 发票类型
export const agencyInvoiceTypeDict = new Dict({
  SPECIAL: { label: '增值税专用发票', value: 1 },
  NORMAL: { label: '普通发票', value: 2 }
})

// 发票冲抵状态
export const agencyInvoiceOffsetStatusDict = new Dict({
  OFFSET: { label: '已冲抵', value: 1 },
  UN_OFFSET: { label: '未冲抵', value: 0 }
})

// 发票开票状态
export const agencyInvoiceStatusDict = new Dict({
  INVOICED: { label: '已开票', value: 1 },
  UN_INVOICED: { label: '未开票', value: 0 }
})

// 确认收入状态
export const recognizeRevenueStatusDict = new Dict({
  NO: { label: '未确认', value: 0 },
  YES: { label: '已确认', value: 1 }
})
